import { useTransferOwnershipProposalMutation } from "../../api/gms/transfer-ownership/transfer-ownership-api"
import { useToastify } from "../../library/toastify/toast-provider";
import { getErrorMessage } from "../../utils/get-error-message.utils";
import { TransferProposalBody } from "../../api/gms/transfer-ownership/transfer-ownership-request";
import { useTransferOwnershipDataState } from "../data-state/use-transferOwnership-data-state";
import { useDispatch } from "react-redux";
import { clearTransferOwnershipState } from "../../features/transfer-ownership/transfer-ownership-slice";

export const useTransferProposalActions = () => {

    const { showToastNotify } = useToastify();
    const dispatch = useDispatch()
    const [transferOwnership, { isLoading: isLoadingTransferOwnership }] = useTransferOwnershipProposalMutation();
    const { formattedCurrentOwner, selectedProposals, formattedNewOwner } = useTransferOwnershipDataState()

    const handleTransferProposal = async () => {
        try {
            if (!selectedProposals || selectedProposals.length === 0) {
                showToastNotify("Select at least one proposal.", "warning");
                return;
            }

            if (!formattedCurrentOwner.id || !formattedNewOwner.id || formattedCurrentOwner.id === formattedNewOwner.id) {
                showToastNotify("Please select valid, different owners.", "warning");
                return;
            }

            const body:TransferProposalBody = {
                from_user_id: formattedCurrentOwner.id,
                to_user_id: formattedNewOwner.id,
                application_ids: selectedProposals.map((proposal) => proposal.id)
            }
            await transferOwnership(body).unwrap();
            showToastNotify("Proposal ownership transferred successfully.", "success");
            dispatch(clearTransferOwnershipState());
        } catch (error: any) {
            const errMsg = error?.message
            const errorMessage = getErrorMessage(error);
            const finalMsg = errMsg || errorMessage
            showToastNotify(finalMsg, 'error')
        }
    }

    return {
        handleTransferProposal,
        isLoadingTransferOwnership,
    }
}